import { render, staticRenderFns } from "./child-safety-policy.vue?vue&type=template&id=5679d184&scoped=true"
import script from "./child-safety-policy.vue?vue&type=script&lang=js"
export * from "./child-safety-policy.vue?vue&type=script&lang=js"
import style0 from "./child-safety-policy.vue?vue&type=style&index=0&id=5679d184&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5679d184",
  null
  
)

export default component.exports